// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__37gWJ","ranges":"BmiRanges_ranges__3Shmf"};